<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (custom)="onCustom($event)" (detail)="onDetail($event)" [columns]="columns" [dataProviderParams]="params"
              [dataProvider]="importService" [title]="" icon="receipt"></data-table>
</page-content>
